<template>
  <div class="h-100">
    <div class="container-wrapper">
      <h2 class="title">Баланс</h2>
    </div>
    <div class="horizontal-scroll">
      <div class="space-right">
        <BalanceCard class="w-86" />
        <!-- <div class="spacer-dont-touch-me" style="height: 2.5vh;" v-if="!shouldShowPromocode"></div> -->
        <!-- <PromocodeCard v-if="shouldShowPromocode" /> -->
      </div>
      <BillingReminderPanel />
      <div class="d-flex">
        <TransactionsHistory />
      </div>
    </div>

    <RemoteScroller />
  </div>
</template>

<script>
import BalanceCard from "@/components/general/BalanceCard.vue";
import PromocodeCard from "@/components/subscriptions/PromocodeCard.vue";
import TransactionsHistory from "@/components/billing/TransactionsHistory.vue";

import BillingReminderPanel from "@/components/billing/BillingReminderPanel.vue";

import RemoteScroller from "@/components/RemoteScroller.vue";

export default {
  components: {
    BalanceCard,
    PromocodeCard,
    TransactionsHistory,
    BillingReminderPanel,
    RemoteScroller
  },
  computed: {
    subscription() {
      return this.$store.state.subscription;
    },
    isActive() {
      return this.subscription && this.subscription.amount;
    },
    shouldShowPromocode() {
      return !this.isActive;
    }
  }
};
</script>

<style scoped>
h3 {
  font-size: 3.6vh;
}
h4 {
  font-size: 2.7vh;
}

h5 {
  font-size: 2vh;
}

.w-86 {
  width: 86vh;
}

.w-inherit {
  width: inherit;
}

.space-right {
  margin: 3.3vh 3.3vh 0 0;
  width: fit-content;
}

.pt-20 {
  padding-top: 2.2vh;
}

.subscription-plan {
  position: relative;
  width: 37.3vh;
  padding: 3.3vh 3.3vh 4vh;
  color: #ededed;
  margin-right: 2vh;
  height: 57vh;
  border-radius: 1vh;
  background: #1d1d1d;
}

.promo-card {
  position: relative;
  width: 75vh;
  padding: 3.3vh 5.5vh 4vh;
  color: #ededed;
  height: auto;
  border-radius: 1vh;
  background: #1d1d1d;
}

.promo-card img {
  height: 23.3vh;
  width: auto;
}

.promo-card p {
  color: #e0e0e0;
  padding-left: 10vh;
  font-size: 1.7vh;
}

.active {
  opacity: 0.6;
}

.subscription-plan:last-child {
  margin-right: 9vh;
}

.space {
  width: inherit;
  padding-right: 5.5vh;
}

.h-100 {
  height: 100vh !important;
}

h2 {
  font-size: 4vh;
}

.subscription-plan button {
  background: #11d180;
  position: absolute;
  bottom: 4vh;
  border: none;
  border-radius: 1vh;
  padding: 1vh 0;
  width: 79%;
  font-size: 2.5vh;
  color: #ededed;
}

.sub-header {
  background: #464646;
  height: 10%;
  justify-content: space-between;
  overflow: auto;
  padding: 5.6vh 5.6vh 0 40.6vh;
  display: flex;
  color: white;
  width: 100%;
  float: right;
  position: relative;
}
</style>
